import React from 'react';
import { Container } from 'reactstrap';
import './partners.css';

export default function Partners() {
  return (
    <section className="partners-section" id="partners">
      <Container>
        <div className="partners-container">
          <div className="partners-header">
            <h2 className="partners-title">Our Partners</h2>
            <div className="partners-title-underline"></div>
          </div>

          <div className="partners-description">
            <p>
              Open to strategic collaboration that drive the success of
              MCGPchain ecosystem.
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
